import { arrayOf, number, oneOf, shape, string } from 'prop-types';
import React from 'react';

import api from '../REST/api';
import withResolved from '../REST/with-resolved';
import LogEntry from './LogEntry';

function shouldMerge(changeset, change) {
  return (
    changeset &&
    changeset.timestamp === change.timestamp &&
    changeset.changedBy === change.changedBy
  );
}

function mergeChanges(log) {
  return log.reduce((partialLog, change) => {
    const lastChangeSet = partialLog[partialLog.length - 1];

    if (shouldMerge(lastChangeSet, change)) {
      lastChangeSet.changes.push(change);
    } else {
      partialLog.push({
        timestamp: change.timestamp,
        changedBy: change.changedBy,
        changes: [change],
      });
    }

    return partialLog;
  }, []);
}

function Changelog({ longLog }) {
  const shortLog = mergeChanges(longLog);
  return (
    <ul className="list-unstyled">
      {shortLog.map((changeSet, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={idx} className="mb-2">
          <LogEntry {...changeSet} />
        </li>
      ))}
    </ul>
  );
}

Changelog.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  contentType: oneOf([
    'account',
    'brand',
    'campaign',
    'opportunity',
    'quote',
    'contact',
    'zms_am_merchant',
  ]).isRequired,
  objectId: number.isRequired, // eslint-disable-line react/no-unused-prop-types

  longLog: arrayOf(shape({ timestamp: string.isRequired })).isRequired,
};

export default withResolved({
  query: api.getChangelog,
  deriveQueryArgs: ({ contentType, objectId }) => ({ contentType, objectId }),
  as: 'longLog',
})(Changelog);
